import { useState, useEffect, useCallback, useRef } from 'react';
import { notificationAPI } from '../services/api';

/**
 * Hook de notifications — interroge l'API toutes les 60 secondes
 * Retourne les compteurs pour les pastilles de la sidebar
 */
const useNotifications = () => {
  const [counts, setCounts] = useState({
    messages_unread:  0,
    quick_quotes_new: 0,
    orders_new:       0,
    requests_total:   0,
  });

  const intervalRef = useRef(null);

  const refresh = useCallback(() => {
    notificationAPI.counts()
      .then(({ data }) => {
        if (data.data) setCounts(data.data);
      })
      .catch(() => {}); // silencieux — les pastilles ne sont pas critiques
  }, []);

  useEffect(() => {
    refresh(); // chargement initial
    intervalRef.current = setInterval(refresh, 60000); // toutes les 60s
    return () => clearInterval(intervalRef.current);
  }, [refresh]);

  return { counts, refresh };
};

export default useNotifications;
